import { get, head } from 'lodash';
import { CONFLICT } from 'http-status-codes';
import { DAILY_LIMIT_ERROR_CODE, CUSTOMER_DEVICE_ENROLLED_ERROR_CODE } from '../../config';
import { getStatusMappingList } from '../statusMapping/selectors';
import ApiConstants from '../../config/apiConstants';
import { CONST_FILE_UPLOAD } from '../../config/constants';
import { hasGroupApprovalsEnabled } from '../modes/selectors';

export const getBatch = (state) => state.batch;
export const getBatchName = (state) => get(state, 'batch.name', undefined);
export const getBatchId = (state) => get(state, 'batch.id', undefined);
export const getBatchContextId = (state) => state.batch.context_id;
export const isBatch = (state) => state.batch && state.batch.isBatch;
export const isBatchTypeUpload = (state) => get(state, 'batch.batchType', '') === CONST_FILE_UPLOAD.BATCH_TYPE;
export const getBatchType = (state) => get(state, 'batch.batchType');

export const getBatchAuthorisation = (state) => get(state, 'batch.authorisation', '');
export const getBatchAuthorisationErrorCode = (state) => get(state, 'batch.authorisation.error.code', 0);
export const getBatchAuthorisationStatus = (state) => get(state, 'batch.authorisation.status', '');
export const getBatchAuthorisationType = (state) => get(state, 'batch.confirmation.authType', '');
export const getBatchConfirmationStatus = (state) => get(state, 'batch.confirmation.status', '');
export const getBatchConfirmationErrorCode = (state) => get(state, 'batch.confirmation.error.code', 0);
export const getBatchPaymentError = (state) => get(state, 'batch.confirmation.error');
export const getBatchAuthorisers = (state) => get(state, 'batch.authorisers', []);
export const getBatchIsDefaultAuthorisers = (state) => get(state, 'batch.isDefaultAuthorisers', false);
export const getBatchGroupAuthorisers = (state) => get(state, 'batch.authorisersGroup', []);

export const getApproverInfo = (state) => {
	const userList = get(state, 'batch.authorisation.user_list', []);
	const user = head(userList);
	if (user) {
		const { approver_name, approver_id } = user;
		return { approver_name, approver_id };
	}
	return null;
};

export const getBatchTotalLimitExceeded = (state) => {
	const responseCode = get(state, 'batch.authorisation.responseCode', 0);
	const code = getBatchAuthorisationErrorCode(state);
	return responseCode === CONFLICT && code !== DAILY_LIMIT_ERROR_CODE;
};
export const isUnauthorisedDailyLimit = (state) => {
	const code = getBatchAuthorisationErrorCode(state);
	return code === DAILY_LIMIT_ERROR_CODE;
};

export const isConfirmedDailyLimit = (state) => {
	const code = getBatchConfirmationErrorCode(state);
	return code === DAILY_LIMIT_ERROR_CODE;
};

export const isUserDeviceNotEnrolled = (state) => {
	const code = getBatchConfirmationErrorCode(state);
	return code === CUSTOMER_DEVICE_ENROLLED_ERROR_CODE;
};

export const getBatchPaymentsStatus = (state) => {
	const statusMappingList = getStatusMappingList(state);
	return get(state, 'batch.confirmation.payments', []).map((payment) => ({
		...payment,
		statusMessage: get(statusMappingList, payment.code, ''),
	}));
};

export const getFPBatchSingleAuthorisersList = (state) => get(state, 'batch.singleAuthoriserList', []);

export const getFPBatchMultiAuthorisersList = (state) => get(state, 'batch.multiAuthoriserList', []);

export const getBatchRequiresAuthorisation = (state) =>
	get(state, 'batch.authorisation.status', '') === ApiConstants.obligate;

export const isBatchConfirmationObligated = (state) => getBatchConfirmationStatus(state) === ApiConstants.obligate;

export const getBatchPaymentRequiresAuthorisers = (state) => {
	const authorisersRequired = getBatchRequiresAuthorisation(state);
	const hasAuthorisers = hasGroupApprovalsEnabled(state)
		? getBatchGroupAuthorisers(state).length > 0
		: getBatchAuthorisers(state).length > 0;
	return authorisersRequired && !hasAuthorisers;
};

export const isBatchTRAObligate = (state) => get(state, 'batch.isTRAObligate', false);
